// src/components/CheckSoccerPredictions.js
import React, {useContext, useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { GiSoccerBall } from 'react-icons/gi';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';
import { DEFAULT_HIGH_ODDS_AI_ENABLED } from '../utils/highOddsAI';
import { LanguageContext } from '../context/LanguageContext';

const CheckSoccerPredictions = () => {
  const navigate = useNavigate();
  const { t } = useContext(LanguageContext);
  const [highOddsAIEnabled, setHighOddsAIEnabled] = useState(null);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const snap = await getDoc(doc(db, 'appSettings', 'highOddsAI'));
        setHighOddsAIEnabled(snap.exists() && typeof snap.data().enabled === 'boolean'
          ? snap.data().enabled
          : DEFAULT_HIGH_ODDS_AI_ENABLED);
      } catch (err) {
        setHighOddsAIEnabled(DEFAULT_HIGH_ODDS_AI_ENABLED);
      }
    };
    loadSettings();
  }, []);

  const handleNormalPredictions = () => {
    navigate('/predictions')
  };

  const handleHighOddsAI = () => {
    navigate('/high-odds-ai')
  };

  return (
    <div className="flex flex-col w-full max-w-[400px] mx-auto space-y-3">
      {/* Button 1: Normal Predictions */}
      <button
        onClick={handleNormalPredictions}
        className="bg-[#27ae60] text-white text-center font-bold py-2 rounded shadow hover:bg-green-600 transition flex items-center justify-center gap-2"
      >
        {/* //VEZI TOATE PREDICTIILE NORMALE */}
        <GiSoccerBall size={18} />
        {t('txt.soccerNormalOdds')}
      </button>

      {/* Button 3: High Odds AI (activa/dezactiva din admin) */}
      {highOddsAIEnabled && (
        <button
          onClick={handleHighOddsAI}
          className="bg-[#27ae60] text-white text-center font-bold py-2 rounded shadow hover:bg-green-600 transition flex items-center justify-center gap-2"
        >
          <GiSoccerBall size={18} />
         {t('txt.highOddsAI')}
        </button>
      )}
    </div>
  );
};

export default CheckSoccerPredictions;
